import EA from '../helpers/init';
import Swiper from 'swiper';
import gsap from 'gsap';

export default EA.Methods.textImageSlider = ($this) => {
    const sliderEl = $this.querySelector('.text-slider-swiper');
    const cursor = $this.querySelector('.slider-cursor');
    let slider;

    if (sliderEl) {
        slider = new Swiper(sliderEl, {
            slidesPerView: 'auto',
            spaceBetween: 8,
        });
    }

    // Custom cursor
    const setCursor = () => {
        sliderEl.addEventListener('mousemove', (function (e) {        
            const rect = sliderEl.getBoundingClientRect();
            const posX = e.clientX - rect.left;
            const elLimit1 = sliderEl.clientWidth * 0.10;
            const elLimit2 = sliderEl.clientWidth * 0.90;        
    
            if (posX > elLimit2) {
                sliderEl.classList.add('cursor-enabled-right');            
            } else if (posX < elLimit1) {
                sliderEl.classList.add('cursor-enabled-left');            
            } else {
                sliderEl.classList.remove('cursor-enabled-right');
                sliderEl.classList.remove('cursor-enabled-left');            
            }
        }));

        sliderEl.addEventListener('mouseleave', function () {
            sliderEl.classList.remove('cursor-enabled-right');
            sliderEl.classList.remove('cursor-enabled-left');  
        });

        sliderEl.addEventListener('click', function () {
            if (sliderEl.classList.contains('cursor-enabled-right')) {
                slider.slideNext();
            } else if (sliderEl.classList.contains('cursor-enabled-left')) {
                slider.slidePrev();
            }
        });

        if (window.innerWidth > 1200) {
            gsap.set(cursor, { xPercent: -50, yPercent: -50 });

            const ball = cursor;
            const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
            const mouse = { x: pos.x, y: pos.y };

            const xSet = gsap.quickSetter(ball, 'x', 'px');
            const ySet = gsap.quickSetter(ball, 'y', 'px');

            sliderEl.addEventListener('mousemove', e => {
                mouse.x = e.x;
                mouse.y = e.y;
            });

            const dt = 0.42;
            gsap.ticker.add(() => {
                pos.x += (mouse.x - pos.x) * dt;
                pos.y += (mouse.y - pos.y) * dt;
                xSet(pos.x);
                ySet(pos.y);
            });
        }
    };

    setCursor();

    window.addEventListener('resize', () => {
        setCursor();
    });
};